import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { getIcon } from "./utils/utils";
import MenuIcon from "@material-ui/icons/Menu";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

interface Menu {
  id: number;
  name: string;
  subMenus: SubMenu[];
}

interface SubMenu {
  id: number;
  name: string;
  link: string;
}

interface SideBarProps {
  heading: string;
  menus: Menu[];
}
const SideBar: React.FC<SideBarProps>  = (props: any) => {
  const navigate = useNavigate();
  const { categoryId, templateID } = useParams();
  const [isSideNavOpen, setIsSideNavOpen] = useState<boolean>(false);
  const [activeMenu, setActiveMenu] = useState(1);
  const [activeSubMenu, setActiveSubMenu] = useState<any>(null);

  useEffect(() => {
    if (categoryId != null) {
      setActiveMenu(Number(categoryId));
      if (templateID) setActiveSubMenu(Number(templateID));
    }
  }, [categoryId]);

  const toggleSideNav = () => {
    setIsSideNavOpen((prevState) => !prevState);
  };

  const handleSubMenuClick = (submenu: any) => {
    setActiveSubMenu(submenu.id);
    navigate(`${submenu.link}/${submenu.id}`, { state: submenu });
  };

  const handleMenuClick = (menu: any) => {
    if (activeMenu == menu.id) {
      setActiveMenu(0);
    } else {
      setActiveMenu(() => menu.id);
      handleSubMenuClick(menu.subMenus[0]);
    }
  };

  return (
    <div data-testid="side-container" className="side-container">
      <div data-testid="side-nav" className={`side-nav ${isSideNavOpen ? "open" : ""}`}>
        <div className="side-nav-header">
          {!isSideNavOpen ? <span>{props.heading}</span> : ""}
          <div aria-hidden="true" data-testid="side-toggle" className="side-nav-header-icon" onClick={toggleSideNav}>
            <MenuIcon />
          </div>
        </div>
        <nav>
          <ul>
            {props.menus?.length > 0 &&
              props.menus.map((menu: Menu) => (
                <React.Fragment key={menu.id}>
                  <button
                    data-testid={`side-menu${menu.id}`}
                    onClick={() => handleMenuClick(menu)}
                    className={`side-menu  remove-button-default-style-flex ${activeMenu == menu.id ? "menu-active" : ""}`}
                  >
                    {!isSideNavOpen ? <div className="side-nav-heading">{menu.name}</div> : ""}
                    <div data-testid="side-nav-icon" className="side-nav-icon">
                    {activeMenu == menu.id ? <ExpandMoreIcon /> : <ChevronRightIcon />}
                  </div>
                  </button>
                  {menu.subMenus?.length > 0 &&
                    activeMenu == menu.id &&
                    menu.subMenus.map((submenu: SubMenu) => (
                      <React.Fragment key={submenu.id}>
                        <button
                           data-testid={`sub-menu${submenu.id}`}
                          onClick={() => handleSubMenuClick(submenu)}
                          className={`subMenus p-left  remove-button-default-style-flex ${activeSubMenu == submenu.id ? "submenu-active" : ""}`}
                        >
                          <div className="side-nav-icon">{getIcon(submenu.link)}</div>
                          {!isSideNavOpen ? <div>{submenu.name}</div> : ""}
                        </button>
                      </React.Fragment>
                    ))}
                </React.Fragment>
              ))}
          </ul>
        </nav>
      </div>
      <div className="outlet-container">
        <Outlet />
      </div>
    </div>
  );
};

export default SideBar;
